import { MAIN_FILTERS, MAIN_FILTERS_WITH_AMENITIES } from "../../data/filtersList";

const reorderFilter = (region: any, includeAmenities = false) => {
  const baseFilters = includeAmenities ? MAIN_FILTERS_WITH_AMENITIES : MAIN_FILTERS;
  const ORDERED_FILTERS = JSON.parse(JSON.stringify(baseFilters));

  if (
    region?.location?.country?.long_name == "Australia" ||
    region?.location?.country?.long_name == "United States"
  ) {
    const element = ORDERED_FILTERS.splice(2, 1)[0];

    // Insert the element at the fifth position (index 4)
    ORDERED_FILTERS.splice(4, 0, element);
  }

  return ORDERED_FILTERS;
};
export const getLocalityOrUniversityTitle = (
  countryShortName: string,
  sourceCountry: string,
  filtersState: any,
) => {
  if (countryShortName !== sourceCountry) {
    return !filtersState?.university ? "University" : "";
  }
  return !filtersState?.locality ? "Locality" : "";
};

export const getBadgeValue = (
  isWhitelabel: boolean,
  isUniversityPartner: boolean,
  whitelabelTitle: string,
  title: string,
) => {
  if (!isWhitelabel) return title;
  return isUniversityPartner && whitelabelTitle === "University" ? "Campuses" : whitelabelTitle;
};

export default reorderFilter;
